import styled, { css } from "styled-components";
import Colors from "constants/Colors";
import { QuicksandBold, QuicksandLight } from "components/Text";

export const Content = styled.div`
  //  min-height: 700px;
  //  background-color: #2f2;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${Colors.WHITE};

  margin-bottom: 24px;
  background: ${Colors.WHITE};
  border-radius: 8px;
  border: 1px 1px 1px 1px solid;
  box-sizing: border-box;
  //border: 1px solid ${Colors.ORANGE[0]};
  //  box-shadow: 0px 17px 17px 6px ${Colors.GRAY[4]};
  box-shadow: 0px 15px 15px rgba(0, 0, 0, 0.1);
  padding: 10px 10px;
`;

export const Fieldset = styled.fieldset`
  border: solid;
  border-color: ${Colors.GRAY[4]};
  border-width: 0px 0px 2px 0px;
  padding: 0px 10px 20px 0px;
  & + Fieldset {
    border: none;
  }
`;
export const Head = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const AdvisoryText = styled.label`
  ${QuicksandLight}
  font-style: normal;
  font-size: 12px;
`;
export const FieldLabel = styled.label`
  ${QuicksandLight}
  font-style: normal;
  font-size: 14px;
  line-height: 150%;
  padding-left: 15px;
`;

export const Heading = styled.h2`
  color: ${Colors.GRAY[6]};
  padding-left: 10px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-top: 20px;
  width: 100%;
  padding: 0px 0px 0px 20px;
`;

export const BackToList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;

export const ButtonContent = styled.div`
  display: flex;
  flex-direction: auto;
  justify-content: space-evenly;
  background-color: #fff;
`;

export const CalendarContainer = styled.div`
  z-index: 1;
  top: 60px;
  right: 24px;
  position: absolute;
  padding-bottom: 50px;
`;

export const BorderSwitch = styled.div`
  background: ${Colors.GRAY[6]};
  padding-left: 1px;
  border-radius: 14px;
  width: 57px;
  padding-top: 1px;
  padding-right: 1px;
  height: 30px;
  display: -webkit-inline-box;
  margin-left: 5px;

  ${({ newBorder }) =>
    newBorder
      ? css`
          margin-top: 10px;
        `
      : ""}
`;

export const SelectField = styled.select`
  width: 100%;
  position: relative;
  height: 42px;
  padding: 8px;
  border: solid 1px ${Colors.GRAY[3]};
  border-radius: 8px;
  background: white;
  font-size: 16px;
  color: ${Colors.GRAY[1]};
  outline: none;
  align-self: auto;
  box-sizing: border-box;
  text-align: initial;
  margin-bottom: 20px;
  ${QuicksandBold}

  transition: background 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: ${Colors.GRAY[3]};
  }

  &[disabled] {
    background-color: ${Colors.GRAY[4]};
    color: ${Colors.GRAY[0]};
  }
`;
